import React from 'react'
import i18 from '../../../../i18'

const TYPE_PARTNER_VSZ = 'PARTNER_VSZ';


class RowProcessed extends React.Component {
    constructor(props) {
        super(props);
        this._notificationSystem = null;
        this.state = {
            invoice: {},
            bank: {},
            showCloseButton: false,
            type: '',
            index: 0,
            typeOfTraffic: '',
            typeOfItem: '',
            typeOfVSZ: '',
            isPartnerType: false,
            invoiceNumber: '',
            companyName: '',
            announcement: '',
            main_bookkeeping_number: '',
            legal_title: ''
        }
    }

    /**
     * @deprecated To be deprecated in React v17.
     * todo: Use new lifecycle static getDerivedStateFromProps instead.
     */
    componentWillReceiveProps = (nextProps) => {
        this.setState({
            invoice: nextProps.invoice,
            typeOfTraffic: nextProps.invoice.typeOfTraffic,
            isPartnerType: nextProps.invoice.typeOfItem === TYPE_PARTNER_VSZ,
            typeOfItem: nextProps.invoice.typeOfItem,
            typeOfVSZ: nextProps.invoice.typeOfVSZ,
            invoiceNumber: nextProps.invoice.invoiceNumber,
            companyName: nextProps.invoice.companyName,
            type: nextProps.type,
            announcement: nextProps.invoice.announcement ? nextProps.invoice.announcement : '-',
            main_bookkeeping_number: nextProps.invoice.main_bookkeeping_number,
            legal_title: nextProps.invoice.typeOfItem === TYPE_PARTNER_VSZ ? (nextProps.invoice.typeOfVSZ === 'v' ? 'V01' : 'K01') : nextProps.invoice.legal_title,
            index: nextProps.keyIndex,
            bank: nextProps.bank,
        })
    };

    onElementChange = (event) => {
        event.preventDefault();
        let elementName = event.target.attributes.name.nodeValue;
        let invoice = this.state.invoice;
        invoice[elementName] = event.target.value;
        this.setState({
            [elementName]: event.target.value,
            invoice: invoice
        });
    };

    onElementBlur = (event) => {

        event.preventDefault();
        let elementName = event.target.attributes.name.nodeValue;
        let invoice = this.state.invoice;

        // if (
        //     this.props.bank.upload.company.accountant_program_id === 2
        //     && elementName === 'main_bookkeeping_number'
        //     && (event.target.value < 100000000 || event.target.value > 999999999)
        // ) {
        //     alert('A főkönyvi számnak 9 karakteresnek kell lennie. A beállítás nem lett elmentve.');
        //
        //     invoice[elementName] = '';
        //     this.setState({
        //         [elementName]: '',
        //         invoice: invoice
        //     });
        //
        //     return false;
        // }

        invoice[elementName] = event.target.value;
        this.setState({
            [elementName]: event.target.value,
            invoice: invoice
        });
    };

    onSelectChange = () => {
        this.setState({
            isPartnerType: false,
            showCloseButton: true,
        })
    };

    onCloseButtonClick = () => {
        this.setState({
            isPartnerType: true,
            showCloseButton: false,
        })
    };

    onCreateRule = (event) => {
        if (!this.state.main_bookkeeping_number) {
            this.props._addNotification('Kérünk ellenőrizze a Fők. szám mezőt.', 'error');
            return
        }
        if (this.props.bank.upload.company.accountant_program_id === 2) {
            if (!this.state.legal_title) {
                this.props._addNotification('Kérünk ellenőrizze a Jogcímkód mezőt.', 'error');
                return
            }
        }

        let invoice = this.state.invoice;

        invoice.type = 'RULE';
        invoice.main_bookkeeping_number = '';
        invoice.legal_title = '';
        invoice.id = invoice.id.substring(0, invoice.id.lastIndexOf("#")) + '#';

        if (!this.leastOneCheckBoxSelected()) {
            invoice.announcementCbox = true;
            invoice.companyChkBox = true;
            invoice.invoiceChkBox = true;
            invoice.typeOfTrafficChkBox = true;
        }

        this.setState({invoice: invoice});

        let data = this.buildInvoiceObj();
        this.props.onCreateRule(event, data, this.state.type);
    };

    buildInvoiceObj = () => {
        let data = {};

        if (this.state.invoice.announcementCbox) {
            data.announcement = this.state.invoice.announcement
        }

        if (this.state.invoice.companyChkBox) {
            data.companyName = this.state.invoice.companyName
        }

        if (this.state.invoice.invoiceChkBox) {
            data.invoiceNumber = this.state.invoice.invoiceNumber
        }

        if (this.state.invoice.typeOfTrafficChkBox) {
            data.typeOfTraffic = this.state.typeOfTraffic
        }

        data.main_bookkeeping_number = this.state.main_bookkeeping_number;
        data.legal_title = this.state.legal_title;
        data.sum_type = (this.state.invoice.sum > 0 ? '+' : '-');

        return data;
    };

    leastOneCheckBoxSelected = () => {
        return this.state.invoice.typeOfTrafficChkBox
            || this.state.invoice.invoiceChkBox
            || this.state.invoice.companyChkBox
            || this.state.invoice.announcementCbox;
    };

    handleChangeChk = event => {
        let invoice = this.state.invoice;
        invoice[event.target.attributes.name.nodeValue] = event.target.value === 'on';
        this.setState({invoice: invoice})
    };

    render() {
        let typeOfTrafficChkBoxId = 'type_of_traffic-' + this.state.index.toString();
        let invoiceChkBoxId = 'invoice-' + this.state.index.toString();
        let companyNameChkBoxId = 'company_name-' + this.state.index.toString();
        let announcementChkBoxId = 'announcement-' + this.state.index.toString();

        return (
            <tr>
                <td>
                    {this.state.showCloseButton
                        ? <div>
                            <input
                                id={typeOfTrafficChkBoxId}
                                type="checkbox"
                                name='typeOfTrafficChkBox'
                                onChange={(event) => this.handleChangeChk(event)}
                            />
                            <label htmlFor={typeOfTrafficChkBoxId}/>
                            <input
                                type='text'
                                className='no-border-underline-text-input typeOfTraffic'
                                name='typeOfTraffic'
                                value={this.state.typeOfTraffic}
                                onChange={(event) => this.onElementChange(event)}
                            />
                        </div>
                        : <span>{this.state.typeOfTraffic}</span>
                    }
                </td>
                <td>
                    {this.state.invoice.day}
                </td>
                <td>
                    {new Intl.NumberFormat('hu-HU', {minimumFractionDigits: 2, maximumFractionDigits: 2}).format(this.state.invoice.sum)} {this.state.invoice.currency}
                </td>
                <td className='invoice-number-td'>
                    {this.state.showCloseButton
                        ? <div>
                            <input
                                type="checkbox"
                                id={invoiceChkBoxId}
                                name='invoiceChkBox'
                                onChange={(event) => this.handleChangeChk(event)}
                            />
                            <label htmlFor={invoiceChkBoxId}>{this.state.invoiceNumber}</label>
                        </div>
                        : <span>{this.state.invoiceNumber}</span>
                    }
                </td>
                <td>
                    {this.state.showCloseButton
                        ? <div>
                            <input
                                id={companyNameChkBoxId}
                                type="checkbox"
                                name='companyNameChkBox'
                                onChange={(event) => this.handleChangeChk(event)}
                            />
                            <label htmlFor={companyNameChkBoxId}/>
                            <input
                                type='text'
                                className='no-border-underline-text-input companyName'
                                name='companyName'
                                value={this.state.companyName}
                                onChange={(event) => this.onElementChange(event)}
                            />
                        </div>
                        : <span>{this.state.companyName ? this.state.companyName : '-'}</span>
                    }
                </td>
                <td>
                    {this.state.showCloseButton
                        ? <div>
                            <input
                                id={announcementChkBoxId}
                                type="checkbox"
                                name='announcementChkBox'
                                onChange={(event) => this.handleChangeChk(event)}
                            />
                            <label htmlFor={announcementChkBoxId}/>
                            <input
                                type='text'
                                className='no-border-underline-text-input announcement'
                                name='announcement'
                                value={this.state.announcement}
                                onChange={(event) => this.onElementChange(event)}
                            />
                        </div>
                        : <span>{this.state.announcement}</span>
                    }
                </td>
                <td>
                    {this.state.isPartnerType
                        ? <a
                            className='next-step-small next-step'
                            onClick={() => this.onSelectChange()}
                        >
                            Szabály létrehozása
                        </a>
                        : (this.state.showCloseButton
                                ? <span>Szabály&nbsp;beállítása&nbsp;<i className="font-17-red-icon fa fa-times" onClick={this.onCloseButtonClick} aria-hidden="true"></i></span>
                                : 'Szabály beállítva'
                        )
                    }
                </td>
                <td className='text-center'>
                    {this.state.isPartnerType
                        ? <span>- nincs párosítva -</span>
                        : <input
                            type='text'
                            className={'bordered-input mainBookKeepingNumber-input'}
                            name='main_bookkeeping_number'
                            value={this.state.main_bookkeeping_number}
                            onChange={(event) => this.onElementChange(event)}
                            onBlur={(event) => this.onElementBlur(event)}
                        />
                    }
                </td>
                {this.props.bank.upload.company.accountant_program_id === 2
                    ? <td className='text-center'>
                        {!this.state.isPartnerType
                            ? <select
                                className={'bordered-input legalTitle-input'}
                                name='legal_title'
                                value={this.state.legal_title}
                                onChange={(event) => this.onElementChange(event)}
                            >
                                <option value=""></option>
                                <option value="B03">B03 - Kölcsönfelvétel</option>
                                <option value="B04">B04 - Tagi kölcsön felvétele</option>
                                <option value="B05">B05 - Tartós alapítói vagyon rendelkezésre bocsátása</option>
                                <option value="B06">B06 - Folyósított kölcsön és kamata</option>
                                <option value="B13">B13 - Kapott osztalék</option>
                                <option value="B99">B99 - Pénzbevétel egyéb forrásból</option>
                                <option value="K03">K03 - Kölcsön visszafizetése</option>
                                <option value="K04">K04 - Tagi kölcsön visszafizetése</option>
                                <option value="K05">K05 - Tartós alapítói vagyon visszafizetése</option>
                                <option value="K06">K06 - Kölcsön folyósítása</option>
                                <option value="K07">K07 - Munkabér</option>
                                <option value="K08">K08 - Foglalkoztatás terhei</option>
                                <option value="K09">K09 - ÁFA</option>
                                <option value="K10">K10 - Nyereséget terhelő adók</option>
                                <option value="K11">K11 - Helyi adók</option>
                                <option value="K12">K12 - Egyéb adók</option>
                                <option value="K13">K13 - Fizetett osztalék</option>
                                <option value="K99">K99 - Egyéb pénzkiadás</option>
                                <option value="T01">T01 - Technikai</option>
                            </select>
                            : <span>V/SZ partner beállítva<br/>({this.state.legal_title})</span>}
                    </td>
                    : null
                }
                <td>
                    <div className={this.state.isPartnerType ? 'd-none' : 'min-width-50'}>
                        <i onClick={(event) => this.onCreateRule(event)} name='final' title={i18.CUSTOMER._createRulesAndProcess} className='fa fa-dot-circle-o' aria-hidden='true'/> &nbsp;&nbsp;
                        <i onClick={(event) => this.onCreateRule(event)} name='temporarily' title={i18.CUSTOMER._oneTimeProcessing} className='fa fa-check-circle' aria-hidden='true'/>
                    </div>
                </td>
            </tr>
        )
    }
}

export default RowProcessed


// WEBPACK FOOTER //
// ./src/components/bank/steps/assignment/rowprocessed.js